module.exports = __webpack_public_path__ + "static/media/logo.599c5e04.png";